export const extractTrailingSlashFromPath = (path: string) => path.replace(/\/$/, '');
